import * as Sentry from '@sentry/react';

export const defaultIgnoredErrors: (string | RegExp)[] = [
  /chunk \d* failed/i,
  'installations/app-offline', // firebase error which is handled by fallback
  'Database deleted by request of the user', // see issue 607
  'AbortError', // see issue 708
];

function initSentry(isProduction: boolean, release: string, ignoreErrors?: (string | RegExp)[]) {
  const environment = isProduction ? 'production' : 'development';
  const customIgnoreErrors = ignoreErrors ?? [];
  const integrations = [Sentry.browserTracingIntegration()];
  Sentry.init({
    // this dns relates to the current project for all opxp apps
    // if we will need to integrate also another project
    // we will need to extend this via arguments
    dsn: `https://7f8366669ad000e69c4f36ad74653ac8@logging.neuronation.com/10`,
    integrations,
    environment,
    debug: !!process.env.NX_PUBLIC_DEBUG,
    tracesSampleRate: 1.0,
    release,
    replaysSessionSampleRate: 1.0,
    replaysOnErrorSampleRate: 1.0,
    // ignore chunk loading errors - nothing to do with them
    ignoreErrors: [...defaultIgnoredErrors, ...customIgnoreErrors],
  });
}

export const defaultReplayOptions = { maxReplayDuration: 60000 };

function enableReplay() {
  Sentry.addIntegration(Sentry.replayIntegration(defaultReplayOptions));
}

function setUserId(userId: number | string) {
  if (!Sentry.isInitialized()) {
    return;
  }
  Sentry.setUser({ id: userId });
}

function captureMessage(message: string, props?: any) {
  Sentry.withScope((scope) => {
    if (props) {
      scope.setExtras(props);
    }
    Sentry.captureMessage(message);
  });
}

function captureException<T extends Error>(error: T, props?: any) {
  Sentry.withScope((scope) => {
    if (props) {
      scope.setExtras(props);
    }
    Sentry.captureException(error);
  });
}

const SentryService = {
  initSentry,
  captureException,
  captureMessage,
  enableReplay,
  setUserId,
};

export default SentryService;
